import { render, staticRenderFns } from "./TemperatureComponent.vue?vue&type=template&id=062d3eb6&scoped=true"
import script from "./TemperatureComponent.vue?vue&type=script&lang=js"
export * from "./TemperatureComponent.vue?vue&type=script&lang=js"
import style0 from "./TemperatureComponent.vue?vue&type=style&index=0&id=062d3eb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062d3eb6",
  null
  
)

export default component.exports